import type { ProductSpecResponse } from '../../../common/js/productService/ProductServiceClient';

export enum IllustrationType {
  Inforce = 'InForce',
  Basic = 'Basic',
  Supplemental = 'Suppliemental',
}

export type Body = {
  html: string;
  formOrder?: string;
  formType?: string;
  options?: any;
  footer?: string;
};

export interface PaymentOption {
  basePremium: number;
  premium: number;
  waiver: number;
  flatExtra: number;
  total: number;
  annualPremium?: number;
  annualWaiver?: number;
  annualTotal?: number;
  additionalCharge?: number;
  riders: IllustrationRider[];
}

export interface PaymentTerms {
  monthly: PaymentOption;
  annual: PaymentOption;
  semiannual: PaymentOption;
  quarterly: PaymentOption;
}

export interface AdditionalData {
  paymentOptions?: PaymentTerms;
  faceDecreasePaymentOptions?: PaymentTerms;
  productBlock?: string;
  productSpec?: ProductSpecResponse;
}

export type IllustrationRider = {
  type: string;
  premium?: number;
  waiver?: number;
  amount?: number;
};

export enum ProductType {
  WholeLife = 'WholeLife',
  Term = 'Term',
}

export interface PaymentOptionWholeLife {
  basePolicyPremium: number;
  RTRPremium: number;
  GIRPremium: number;
  CIRPremium: number;
  waiverPremium: number;
  RTRWaiverPremium: number;
  GIRWaiverPremium: number;
  CIRWaiverPremium: number;
  totalInitialModalPremiumAnnualized: number;
  totalInitialModalPremium: number;
}

export interface WholeLifePaymentTerms {
  monthly?: PaymentOptionWholeLife;
  annual?: PaymentOptionWholeLife;
  semiannual?: PaymentOptionWholeLife;
  quarterly?: PaymentOptionWholeLife;
}

export const VantageTermECPFormNumbers = {
  NY: 'TL-NY-2018',
  DE: 'TL-2018',
  CA: 'TL-CA-2018',
  DC: 'TL-DC-2018',
  FL: 'TL-FL-2018',
  ND: 'TL-ND-2018',
  SD: 'TL-SD-2018',
  ICC: 'ICC18TL',
};

export const mmopmProductBlocks = {
  MMOPMTerm: {
    99: 'MMOPMTerm_2000b1',
    2004: 'MMOPMTerm_2004b1',
    2005: 'MMOPMTerm_2005b1',
  },
  MMOPMTermAPT80: {
    99: 'MMOPMTermAPT80_2000b1',
    2006: 'MMOPMTermAPT80_2006b1',
  },
};
